import { gql } from '@apollo/client';

export const UPDATE_LAST_ACTIVITY = gql`
  mutation updateLastActivity($adAccountId: ID!) {
    updateLastActivity(adAccountId: $adAccountId)
  }
`;
